"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  AppEnvironment: true,
  GOAL_OF_JOINING_QUESTION_NAME: true,
  STANDARD_DRINKS_DAY_QUESTION_NAME: true,
  WENT_3_DAYS_WITHOUT_DRINKING_QUESTION_NAME: true,
  PREGNANT_OR_BREASTFEEDING_QUESTION_NAME: true,
  DSM5_PHYSICIAN_COMMENT_SECTION_NAME: true,
  MEDICAL_INTAKE_PHYSICIAN_COMMENT_SECTION_NAME: true,
  DSM5_PHYSICIAN_COMMENT_QUESTION_NAME: true,
  MEDICAL_INTAKE_PHYSICIAN_COMMENT_QUESTION_NAME: true,
  HISTORY_OF_ILLNESS_QUESTION_NAME: true,
  PATIENT_WAS_INFORMED_QUESTION_NAME: true,
  CPT_CODE_QUESTION_NAME: true,
  ICD_CODE_QUESTION_NAME: true,
  PRESCRIPTIONS_QUESTION_NAME: true,
  ASSESSMENT_QUESTION_NAME: true,
  THERAPY_RECOMMENDATION: true,
  MEDICAL_ASSESSMENT_QUESTION_NAMES: true,
  MEDICAL_ASSESSMENT_QUESTION_DESCRIPTIONS: true,
  FREEMIUM_PLAN_ID: true,
  isFreemium: true,
  CANCEL_REASON_OTHER_OPTION_ID: true,
  TRANSITION_PATHS: true,
  SubscriptionStatuses: true,
  SESSION_LIFETIME: true,
  ADMIN_SESSION_LIFETIME: true,
  IDLE_PING_FREQUENCY: true,
  PASSWORD_MIN_LENGTH: true,
  MIN_STRING_TO_SEARCH_LENGTH: true,
  MAX_DAILYCO_GROUP_SESSION_CAPACITY: true,
  ACCEPT_IMAGE_TYPES: true,
  OTHER_POSSIBLE_IMAGE_EXTENSIONS: true,
  ACCEPT_PDF_TYPES: true,
  SessionEvents: true,
  ServiceWorkerEvents: true,
  RoutePathLocation: true,
  PharmacyCopayStatus: true,
  PharmacyOrderStatus: true,
  FEATURE_FLAGS: true,
  CourseStatus: true,
  GroupStatusText: true,
  PatientNotificationGroup: true,
  ClinicianNotificationGroup: true,
  AccountStatus: true,
  PatientStatus: true,
  ErxPrescriptionMedicationStatusType: true,
  ErxPrescriptionStatusType: true,
  ExpeditedShippingFeeMethods: true,
  ExpeditedShippingFee: true,
  RATING_REVIEW_PURPOSES: true,
  BILLING_CHANGES_INTAKE_SURVEY_ID: true,
  SURVEY_ANSWER_TYPES: true,
  VIDEO_CHAT_EVENTS: true,
  MEDICATION_NAMES: true,
  ANSWER_CONFIRM_NALTREXONE_NAME: true,
  ANSWER_CONFIRM_DISULFIRAM_NAME: true,
  INSURERS: true,
  OTHER_INSURER: true,
  ALL_INSURERS_OPTIONS: true,
  STATES_WITH_ACCEPTED_INSURANCE: true,
  FIRST_THERAPY_EXPLAINER_ARTICLE_URL: true,
  SHOW_MODAL_SUCCESS_DURATION: true,
  DETOX_RECOMMENDED_QUESTION_NAME: true,
  Transition: true,
  MESSAGING_CHAT_CHANNEL_TYPE: true,
  SUPPORT_GROUP_CHANNEL_TYPES: true,
  COMMUNITY_CHANNEL_TYPES: true,
  MEMBER_RESTRICTED_CHANNEL_TYPES: true,
  ALL_COMMUNITY_CHANNEL_TYPES: true,
  MAX_CHAT_QUERY_DATA_LIMIT: true,
  MONUMENT_SYSTEM_CHAT_USER_ID: true,
  MENTION_SIGN: true,
  FAKE_HERE_USER_NAME: true,
  FAKE_HERE_USER: true,
  CHAT_ADMIN_ROLE_NAME: true,
  COMMUNITY_EMERGENCY_RESOURCES_CHANNEL_ID: true,
  USER_POSTS_FORBIDDEN_CHAT_CHANNEL_TYPES: true,
  CompanyNames: true,
  CompanyIds: true,
  MESSENGER_TABS: true,
  ALLOWED_MESSAGE_ACTIONS: true,
  MESSAGE_PREVIEWS_TABS: true,
  PATIENT_COMMUNITY_CHAT_URL: true,
  DEFAULT_COMMUNITY_CHAT_URL: true,
  FREE_RESPONSE_SUFFIX: true,
  MANAGE_CALENDAR_TABS: true,
  CLINICIAN_CALENDAR_MANAGE_PARENT_URL: true,
  DEFAULT_CHAT_SEPARATOR_DATE_TITLE_FORMAT: true
};
exports.isFreemium = exports.WENT_3_DAYS_WITHOUT_DRINKING_QUESTION_NAME = exports.VIDEO_CHAT_EVENTS = exports.USER_POSTS_FORBIDDEN_CHAT_CHANNEL_TYPES = exports.Transition = exports.TRANSITION_PATHS = exports.THERAPY_RECOMMENDATION = exports.SubscriptionStatuses = exports.SessionEvents = exports.ServiceWorkerEvents = exports.SURVEY_ANSWER_TYPES = exports.SUPPORT_GROUP_CHANNEL_TYPES = exports.STATES_WITH_ACCEPTED_INSURANCE = exports.STANDARD_DRINKS_DAY_QUESTION_NAME = exports.SHOW_MODAL_SUCCESS_DURATION = exports.SESSION_LIFETIME = exports.RoutePathLocation = exports.RATING_REVIEW_PURPOSES = exports.PharmacyOrderStatus = exports.PharmacyCopayStatus = exports.PatientStatus = exports.PatientNotificationGroup = exports.PRESCRIPTIONS_QUESTION_NAME = exports.PREGNANT_OR_BREASTFEEDING_QUESTION_NAME = exports.PATIENT_WAS_INFORMED_QUESTION_NAME = exports.PATIENT_COMMUNITY_CHAT_URL = exports.PASSWORD_MIN_LENGTH = exports.OTHER_POSSIBLE_IMAGE_EXTENSIONS = exports.OTHER_INSURER = exports.MONUMENT_SYSTEM_CHAT_USER_ID = exports.MIN_STRING_TO_SEARCH_LENGTH = exports.MESSENGER_TABS = exports.MESSAGING_CHAT_CHANNEL_TYPE = exports.MESSAGE_PREVIEWS_TABS = exports.MENTION_SIGN = exports.MEMBER_RESTRICTED_CHANNEL_TYPES = exports.MEDICATION_NAMES = exports.MEDICAL_INTAKE_PHYSICIAN_COMMENT_SECTION_NAME = exports.MEDICAL_INTAKE_PHYSICIAN_COMMENT_QUESTION_NAME = exports.MEDICAL_ASSESSMENT_QUESTION_NAMES = exports.MEDICAL_ASSESSMENT_QUESTION_DESCRIPTIONS = exports.MAX_DAILYCO_GROUP_SESSION_CAPACITY = exports.MAX_CHAT_QUERY_DATA_LIMIT = exports.MANAGE_CALENDAR_TABS = exports.INSURERS = exports.IDLE_PING_FREQUENCY = exports.ICD_CODE_QUESTION_NAME = exports.HISTORY_OF_ILLNESS_QUESTION_NAME = exports.GroupStatusText = exports.GOAL_OF_JOINING_QUESTION_NAME = exports.FREE_RESPONSE_SUFFIX = exports.FREEMIUM_PLAN_ID = exports.FIRST_THERAPY_EXPLAINER_ARTICLE_URL = exports.FEATURE_FLAGS = exports.FAKE_HERE_USER_NAME = exports.FAKE_HERE_USER = exports.ExpeditedShippingFeeMethods = exports.ExpeditedShippingFee = exports.ErxPrescriptionStatusType = exports.ErxPrescriptionMedicationStatusType = exports.DSM5_PHYSICIAN_COMMENT_SECTION_NAME = exports.DSM5_PHYSICIAN_COMMENT_QUESTION_NAME = exports.DETOX_RECOMMENDED_QUESTION_NAME = exports.DEFAULT_COMMUNITY_CHAT_URL = exports.DEFAULT_CHAT_SEPARATOR_DATE_TITLE_FORMAT = exports.CourseStatus = exports.CompanyNames = exports.CompanyIds = exports.ClinicianNotificationGroup = exports.CPT_CODE_QUESTION_NAME = exports.COMMUNITY_EMERGENCY_RESOURCES_CHANNEL_ID = exports.COMMUNITY_CHANNEL_TYPES = exports.CLINICIAN_CALENDAR_MANAGE_PARENT_URL = exports.CHAT_ADMIN_ROLE_NAME = exports.CANCEL_REASON_OTHER_OPTION_ID = exports.BILLING_CHANGES_INTAKE_SURVEY_ID = exports.AppEnvironment = exports.AccountStatus = exports.ASSESSMENT_QUESTION_NAME = exports.ANSWER_CONFIRM_NALTREXONE_NAME = exports.ANSWER_CONFIRM_DISULFIRAM_NAME = exports.ALL_INSURERS_OPTIONS = exports.ALL_COMMUNITY_CHANNEL_TYPES = exports.ALLOWED_MESSAGE_ACTIONS = exports.ADMIN_SESSION_LIFETIME = exports.ACCEPT_PDF_TYPES = exports.ACCEPT_IMAGE_TYPES = void 0;
var _types = require("../../types");
var _lodash = require("lodash");
var _payerContract = require("./payer-contract.constants");
Object.keys(_payerContract).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _payerContract[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _payerContract[key];
    }
  });
});
var _applicationPaths = require("./application-paths.constants");
Object.keys(_applicationPaths).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _applicationPaths[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _applicationPaths[key];
    }
  });
});
var _payment = require("./payment.constants");
Object.keys(_payment).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _payment[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _payment[key];
    }
  });
});
var _insurance = require("./insurance.constants");
Object.keys(_insurance).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _insurance[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _insurance[key];
    }
  });
});
var _employer = require("./employer.constants");
Object.keys(_employer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _employer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _employer[key];
    }
  });
});
var _courses = require("./courses.constants");
Object.keys(_courses).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _courses[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _courses[key];
    }
  });
});
var _countries = require("./countries.constants");
Object.keys(_countries).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _countries[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _countries[key];
    }
  });
});
var _groupCall = require("./group-call.constants");
Object.keys(_groupCall).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _groupCall[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _groupCall[key];
    }
  });
});
var _groups = require("./groups.constants");
Object.keys(_groups).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _groups[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _groups[key];
    }
  });
});
var _visitReason = require("./visit-reason.constants");
Object.keys(_visitReason).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _visitReason[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _visitReason[key];
    }
  });
});
var _querySelectors = require("./query-selectors.constants");
Object.keys(_querySelectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _querySelectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _querySelectors[key];
    }
  });
});
var _MEDICAL_ASSESSMENT_Q, _GroupStatusText, _ExpeditedShippingFee, _CompanyIds;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AppEnvironment = {
  Local: 'local',
  Development: 'development',
  QA: 'qa',
  Production: 'production'
};

// Intake question names
exports.AppEnvironment = AppEnvironment;
var GOAL_OF_JOINING_QUESTION_NAME = 'Goal of Joining';
exports.GOAL_OF_JOINING_QUESTION_NAME = GOAL_OF_JOINING_QUESTION_NAME;
var STANDARD_DRINKS_DAY_QUESTION_NAME = 'Number of Standard Drinks';
exports.STANDARD_DRINKS_DAY_QUESTION_NAME = STANDARD_DRINKS_DAY_QUESTION_NAME;
var WENT_3_DAYS_WITHOUT_DRINKING_QUESTION_NAME = '3+ Days Without Drinking';
exports.WENT_3_DAYS_WITHOUT_DRINKING_QUESTION_NAME = WENT_3_DAYS_WITHOUT_DRINKING_QUESTION_NAME;
var PREGNANT_OR_BREASTFEEDING_QUESTION_NAME = 'Pregnant or Breastfeeding';

// Physician Assessment Survey Questions
exports.PREGNANT_OR_BREASTFEEDING_QUESTION_NAME = PREGNANT_OR_BREASTFEEDING_QUESTION_NAME;
var DSM5_PHYSICIAN_COMMENT_SECTION_NAME = 'DSM-5 Comment';
exports.DSM5_PHYSICIAN_COMMENT_SECTION_NAME = DSM5_PHYSICIAN_COMMENT_SECTION_NAME;
var MEDICAL_INTAKE_PHYSICIAN_COMMENT_SECTION_NAME = 'Intake Comment';
exports.MEDICAL_INTAKE_PHYSICIAN_COMMENT_SECTION_NAME = MEDICAL_INTAKE_PHYSICIAN_COMMENT_SECTION_NAME;
var DSM5_PHYSICIAN_COMMENT_QUESTION_NAME = 'DSM-5 Physician Comment';
exports.DSM5_PHYSICIAN_COMMENT_QUESTION_NAME = DSM5_PHYSICIAN_COMMENT_QUESTION_NAME;
var MEDICAL_INTAKE_PHYSICIAN_COMMENT_QUESTION_NAME = 'Intake Physician Comment';
exports.MEDICAL_INTAKE_PHYSICIAN_COMMENT_QUESTION_NAME = MEDICAL_INTAKE_PHYSICIAN_COMMENT_QUESTION_NAME;
var HISTORY_OF_ILLNESS_QUESTION_NAME = 'History of present illness';
exports.HISTORY_OF_ILLNESS_QUESTION_NAME = HISTORY_OF_ILLNESS_QUESTION_NAME;
var PATIENT_WAS_INFORMED_QUESTION_NAME = 'Patient was informed';
exports.PATIENT_WAS_INFORMED_QUESTION_NAME = PATIENT_WAS_INFORMED_QUESTION_NAME;
var CPT_CODE_QUESTION_NAME = 'CPT Code';
exports.CPT_CODE_QUESTION_NAME = CPT_CODE_QUESTION_NAME;
var ICD_CODE_QUESTION_NAME = 'ICD Code';
exports.ICD_CODE_QUESTION_NAME = ICD_CODE_QUESTION_NAME;
var PRESCRIPTIONS_QUESTION_NAME = 'Prescriptions';
exports.PRESCRIPTIONS_QUESTION_NAME = PRESCRIPTIONS_QUESTION_NAME;
var ASSESSMENT_QUESTION_NAME = 'Assessment';
exports.ASSESSMENT_QUESTION_NAME = ASSESSMENT_QUESTION_NAME;
var THERAPY_RECOMMENDATION = 'Therapy recommendation';
exports.THERAPY_RECOMMENDATION = THERAPY_RECOMMENDATION;
var MEDICAL_ASSESSMENT_QUESTION_NAMES = {
  SPECIAL_MEDICAL_CONDITIONS: 'Special medical conditions',
  HEART_CONDITIONS: 'Heart conditions',
  HISTORY_OF_LIVER_DISEASE: 'History of liver disease',
  HISTORY_OF_KIDNEY_DISEASE: 'History of kidney disease',
  USED_SUBSTANCES: 'Used Substances',
  USED_SUBSTANCES_OPIOIDS: 'Used Substances - Opioids',
  USED_SUBSTANCES_BENZOS: 'Used Substances - Benzos',
  SURGERIES_AND_HOSPITALIZATIONS: 'Surgeries and hospitalizations',
  TAKES_MEDICATIONS: 'Takes medications',
  ALLERGIC_REACTIONS: 'Allergic reactions',
  TAKES_PAIN_MEDICATIONS: 'Takes pain medications',
  WENT_3_DAYS_WITHOUT_DRINKING_QUESTION_NAME: WENT_3_DAYS_WITHOUT_DRINKING_QUESTION_NAME
};
exports.MEDICAL_ASSESSMENT_QUESTION_NAMES = MEDICAL_ASSESSMENT_QUESTION_NAMES;
var MEDICAL_ASSESSMENT_QUESTION_DESCRIPTIONS = (_MEDICAL_ASSESSMENT_Q = {}, _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.SPECIAL_MEDICAL_CONDITIONS, 'Medical conditions'), _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.HEART_CONDITIONS, 'Heart conditions'), _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.HISTORY_OF_LIVER_DISEASE, 'History of liver disease'), _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.HISTORY_OF_KIDNEY_DISEASE, 'History of kidney disease'), _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.USED_SUBSTANCES, 'Used substances in the last 30 days'), _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.USED_SUBSTANCES_OPIOIDS, 'Used substances in the last 30 days - Opioids'), _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.USED_SUBSTANCES_BENZOS, 'Used substances in the last 30 days - Benzos'), _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.SURGERIES_AND_HOSPITALIZATIONS, 'Surgeries and/or hospitalizations'), _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.TAKES_MEDICATIONS, 'Medications'), _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.ALLERGIC_REACTIONS, 'Allergic reactions'), _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.TAKES_PAIN_MEDICATIONS, 'Pain medications'), _defineProperty(_MEDICAL_ASSESSMENT_Q, MEDICAL_ASSESSMENT_QUESTION_NAMES.WENT_3_DAYS_WITHOUT_DRINKING_QUESTION_NAME, 'Has not had 3+ days without drinking in the past 30 days'), _MEDICAL_ASSESSMENT_Q);
exports.MEDICAL_ASSESSMENT_QUESTION_DESCRIPTIONS = MEDICAL_ASSESSMENT_QUESTION_DESCRIPTIONS;
var FREEMIUM_PLAN_ID = 'freemium';
exports.FREEMIUM_PLAN_ID = FREEMIUM_PLAN_ID;
var isFreemium = function isFreemium(planId) {
  return planId === FREEMIUM_PLAN_ID;
};
exports.isFreemium = isFreemium;
var CANCEL_REASON_OTHER_OPTION_ID = 13;
exports.CANCEL_REASON_OTHER_OPTION_ID = CANCEL_REASON_OTHER_OPTION_ID;
var TRANSITION_PATHS = {
  CORE_TO_FREE: 'core_to_free',
  PHYSICIAN_TO_FREE: 'physician_to_free',
  THERAPY_TO_FREE: 'therapy_to_free',
  THERAPY_TO_PHYSICIAN: 'therapy_to_physician'
};
exports.TRANSITION_PATHS = TRANSITION_PATHS;
var SubscriptionStatuses = {
  ACTIVE: 'active',
  CANCELED: 'canceled'
};

// ---- Auto logout / log out / session expiry / signout / sign out ----
exports.SubscriptionStatuses = SubscriptionStatuses;
var SESSION_LIFETIME = 15 * 60 * 1000; // 15 minutes
exports.SESSION_LIFETIME = SESSION_LIFETIME;
var ADMIN_SESSION_LIFETIME = 20 * 60 * 1000; // 20 minutes
exports.ADMIN_SESSION_LIFETIME = ADMIN_SESSION_LIFETIME;
var IDLE_PING_FREQUENCY = 60 * 1000; // 1 minute
exports.IDLE_PING_FREQUENCY = IDLE_PING_FREQUENCY;
var PASSWORD_MIN_LENGTH = 8;
exports.PASSWORD_MIN_LENGTH = PASSWORD_MIN_LENGTH;
var MIN_STRING_TO_SEARCH_LENGTH = 3;
exports.MIN_STRING_TO_SEARCH_LENGTH = MIN_STRING_TO_SEARCH_LENGTH;
var MAX_DAILYCO_GROUP_SESSION_CAPACITY = 200;
exports.MAX_DAILYCO_GROUP_SESSION_CAPACITY = MAX_DAILYCO_GROUP_SESSION_CAPACITY;
var ACCEPT_IMAGE_TYPES = ['image/bmp', 'image/jpeg', 'image/png', 'image/gif'];
exports.ACCEPT_IMAGE_TYPES = ACCEPT_IMAGE_TYPES;
var OTHER_POSSIBLE_IMAGE_EXTENSIONS = ['webp', 'tif', 'jxr', 'bpg', 'jp2', 'jpx', 'jpm', 'svg'];
exports.OTHER_POSSIBLE_IMAGE_EXTENSIONS = OTHER_POSSIBLE_IMAGE_EXTENSIONS;
var ACCEPT_PDF_TYPES = ['application/pdf'];
exports.ACCEPT_PDF_TYPES = ACCEPT_PDF_TYPES;
var SessionEvents = {
  Connected: 'Connected',
  Disconnected: 'Disconnected',
  Reconnected: 'Reconnected',
  Reconnecting: 'Reconnecting',
  Connecting: 'Connecting'
};
exports.SessionEvents = SessionEvents;
var ServiceWorkerEvents = {
  LOGOUT: 'logout',
  LOGIN: 'login'
};
exports.ServiceWorkerEvents = ServiceWorkerEvents;
var RoutePathLocation = {
  HIGHRISK: '/high-risk',
  PROGRAM: '/program',
  SETTINGS: '/settings',
  HOME: '/'
};
exports.RoutePathLocation = RoutePathLocation;
var PharmacyCopayStatus = {
  Pending: 0,
  Received: 1,
  Error: 2,
  Canceled: 3
};
exports.PharmacyCopayStatus = PharmacyCopayStatus;
var PharmacyOrderStatus = {
  Pending: 0,
  Processing: 1,
  Error: 2,
  Canceled: 3
};
exports.PharmacyOrderStatus = PharmacyOrderStatus;
var FEATURE_FLAGS = {
  COMMUNITY: 'community',
  HEALTH_OUTCOMES: 'health_outcomes',
  GROUPS: 'groups',
  INTERNAL_GROUP_RSVPS: 'internal_group_rsvps',
  ADMIN_CHATS: 'admin_chats',
  RATING_REVIEW_NOTIFICATION: 'rating_review_notification',
  PATIENT_FACING_APPOINTMENTS: 'patient_facing_appointments'
};
exports.FEATURE_FLAGS = FEATURE_FLAGS;
var CourseStatus = {
  Active: 'active',
  ComingSoon: 'coming-soon',
  Archived: 'archived'
};
exports.CourseStatus = CourseStatus;
var GroupStatusText = (_GroupStatusText = {}, _defineProperty(_GroupStatusText, _types.GroupStatus.Active, 'Active'), _defineProperty(_GroupStatusText, _types.GroupStatus.ComingSoon, 'Coming Soon'), _defineProperty(_GroupStatusText, _types.GroupStatus.Archived, 'Archived'), _GroupStatusText);
exports.GroupStatusText = GroupStatusText;
var PatientNotificationGroup = {
  Appointment: 'appointment',
  CareTeam: 'care-team',
  Group: 'group',
  Community: 'community',
  Prescription: 'prescription',
  RatingAndReview: 'rating-and-review',
  Insurance: 'insurance'
};
exports.PatientNotificationGroup = PatientNotificationGroup;
var ClinicianNotificationGroup = {
  Appointment: 'clinician-appointment',
  Chat: 'clinician-chat',
  Match: 'clinician-match',
  Group: 'clinician-group'
};
exports.ClinicianNotificationGroup = ClinicianNotificationGroup;
var AccountStatus = {
  New: 1,
  Active: 2,
  Deactivated: 3
};
exports.AccountStatus = AccountStatus;
var PatientStatus = _objectSpread(_objectSpread({}, AccountStatus), {}, {
  RemovedByPatient: 4
});
exports.PatientStatus = PatientStatus;
var ErxPrescriptionMedicationStatusType = {
  Unknown: 0,
  Active: 1,
  Inactive: 2,
  Discontinued: 3,
  Deleted: 4,
  Completed: 5,
  CancelRequested: 6,
  CancelPending: 7,
  Cancelled: 8,
  CancelDenied: 9,
  Changed: 10,
  FullFill: 11,
  PartialFill: 12,
  NoFill: 13
};
exports.ErxPrescriptionMedicationStatusType = ErxPrescriptionMedicationStatusType;
var ErxPrescriptionStatusType = {
  Entered: 1,
  Printed: 2,
  Sending: 3,
  ErxSent: 4,
  FaxSent: 5,
  Error: 6,
  Deleted: 7,
  Requested: 8,
  Edited: 9,
  EpcsError: 10,
  EpcsSigned: 11,
  ReadyToSign: 12,
  PharmacyVerified: 13
};
exports.ErxPrescriptionStatusType = ErxPrescriptionStatusType;
var ExpeditedShippingFeeMethods = {
  USPS_PRIORITY: 'usps_priority',
  FEDEX_STANDARD_OVERNIGHT: 'fedex_standard_overnight',
  USPS_PRIORITY_EXPRESS: 'usps_priority_express',
  FEDEX_PRIORITY_OVERNIGHT: 'fedex_priority_overnight'
};
exports.ExpeditedShippingFeeMethods = ExpeditedShippingFeeMethods;
var ExpeditedShippingFee = (_ExpeditedShippingFee = {}, _defineProperty(_ExpeditedShippingFee, ExpeditedShippingFeeMethods.USPS_PRIORITY, 0), _defineProperty(_ExpeditedShippingFee, ExpeditedShippingFeeMethods.FEDEX_STANDARD_OVERNIGHT, 7), _defineProperty(_ExpeditedShippingFee, ExpeditedShippingFeeMethods.USPS_PRIORITY_EXPRESS, 18), _defineProperty(_ExpeditedShippingFee, ExpeditedShippingFeeMethods.FEDEX_PRIORITY_OVERNIGHT, 21), _ExpeditedShippingFee);

// Corresponds to RatingReviewNotificationPurpose on backend
exports.ExpeditedShippingFee = ExpeditedShippingFee;
var RATING_REVIEW_PURPOSES = {
  GROUP: 'groupCall',
  MONTHLY: 'monthly',
  FIRST_CALL: 'firstVideoCall',
  FIRST_CLINICIAN_RATING: 'firstClinicianRating'
};
exports.RATING_REVIEW_PURPOSES = RATING_REVIEW_PURPOSES;
var BILLING_CHANGES_INTAKE_SURVEY_ID = 13;

// Should be kept in sync with enum in backend
exports.BILLING_CHANGES_INTAKE_SURVEY_ID = BILLING_CHANGES_INTAKE_SURVEY_ID;
var SURVEY_ANSWER_TYPES = {
  TEXT: 1,
  CHECKBOX: 2,
  NONE: 3,
  // If there is an answer of this type in a group of answer options,
  // no other options can be selected if this option is chosen by the user
  UNIQUE_MULTI_CHECKBOX: 4
};
exports.SURVEY_ANSWER_TYPES = SURVEY_ANSWER_TYPES;
var VIDEO_CHAT_EVENTS = {
  RESIZE: 'resize',
  VIDEO_ANCHOR_MOUNT: 'videoAnchorMount',
  VIDEO_ANCHOR_UNMOUNT: 'videoAnchorUnmount',
  VIDEO_INTERVAL_UPDATE: 'videoUpdateByInterval'
};
exports.VIDEO_CHAT_EVENTS = VIDEO_CHAT_EVENTS;
var MEDICATION_NAMES = {
  NALTREXONE: 'naltrexone',
  ACAMPROSTATE: 'acamprostate',
  DISULFIRAM: 'disulfiram'
};
exports.MEDICATION_NAMES = MEDICATION_NAMES;
var ANSWER_CONFIRM_NALTREXONE_NAME = 'Confirm Naltrexone prescription';
exports.ANSWER_CONFIRM_NALTREXONE_NAME = ANSWER_CONFIRM_NALTREXONE_NAME;
var ANSWER_CONFIRM_DISULFIRAM_NAME = 'Confirm Disulfiram prescription';
exports.ANSWER_CONFIRM_DISULFIRAM_NAME = ANSWER_CONFIRM_DISULFIRAM_NAME;
var INSURERS = ['Aetna', 'Cigna', 'UHC/Optum', 'Oscar/Optum', 'Medicare', 'Oxford/Optum', 'CDPHP'];
exports.INSURERS = INSURERS;
var OTHER_INSURER = 'Other';
exports.OTHER_INSURER = OTHER_INSURER;
var ALL_INSURERS_OPTIONS = [].concat(INSURERS, ['Other']);
exports.ALL_INSURERS_OPTIONS = ALL_INSURERS_OPTIONS;
var STATES_WITH_ACCEPTED_INSURANCE = [{
  name: 'New York',
  abbreviation: 'NY',
  insurers: ['Aetna', 'Cigna', 'Medicare', 'UnitedHealthcare', 'Oscar', 'Optum', 'Oxford', 'CDPHP']
}, {
  name: 'New Jersey',
  abbreviation: 'NJ',
  insurers: ['Cigna', 'Medicare']
}, {
  name: 'California',
  abbreviation: 'CA',
  insurers: ['Aetna', 'UHC/Optum', 'Medicare']
}, {
  name: 'Florida',
  abbreviation: 'FL'
}, {
  name: 'Arizona',
  abbreviation: 'AZ',
  insurers: ['Aetna', 'UHC/Optum', 'Medicare', 'AZ Blue', 'Cigna']
}];
exports.STATES_WITH_ACCEPTED_INSURANCE = STATES_WITH_ACCEPTED_INSURANCE;
var FIRST_THERAPY_EXPLAINER_ARTICLE_URL = 'https://joinmonument.com/resources/what-to-expect-from-therapy/';

// After submitting a form in a modal, the duration (ms) that a success message is displayed before
// the modal automatically closes
exports.FIRST_THERAPY_EXPLAINER_ARTICLE_URL = FIRST_THERAPY_EXPLAINER_ARTICLE_URL;
var SHOW_MODAL_SUCCESS_DURATION = 1200;
exports.SHOW_MODAL_SUCCESS_DURATION = SHOW_MODAL_SUCCESS_DURATION;
var DETOX_RECOMMENDED_QUESTION_NAME = 'Detox recommendation';
exports.DETOX_RECOMMENDED_QUESTION_NAME = DETOX_RECOMMENDED_QUESTION_NAME;
var Transition = {
  In: 'in',
  Out: 'out'
};
exports.Transition = Transition;
var MESSAGING_CHAT_CHANNEL_TYPE = 'messaging';
exports.MESSAGING_CHAT_CHANNEL_TYPE = MESSAGING_CHAT_CHANNEL_TYPE;
var SUPPORT_GROUP_CHANNEL_TYPES = {
  GROUP_BOUND: 'support-group',
  // no real channels of this type exists, only static ones
  PUBLIC: 'support-group-public'
};
exports.SUPPORT_GROUP_CHANNEL_TYPES = SUPPORT_GROUP_CHANNEL_TYPES;
var COMMUNITY_CHANNEL_TYPES = {
  PUBLIC: 'community-public',
  ADMIN_POST: 'community-admin-post',
  ADMIN_POST_READONLY: 'community-admin-post-readonly',
  GETTING_STARTED: 'community-getting-started'
};
exports.COMMUNITY_CHANNEL_TYPES = COMMUNITY_CHANNEL_TYPES;
var MEMBER_RESTRICTED_CHANNEL_TYPES = {
  THERAPIST_ONLY: 'member-only-therapist-only',
  PHYSICIAN_ONLY: 'member-only-physician-only'
};
exports.MEMBER_RESTRICTED_CHANNEL_TYPES = MEMBER_RESTRICTED_CHANNEL_TYPES;
var ALL_COMMUNITY_CHANNEL_TYPES = [].concat(_toConsumableArray((0, _lodash.values)(COMMUNITY_CHANNEL_TYPES)), _toConsumableArray((0, _lodash.values)(SUPPORT_GROUP_CHANNEL_TYPES)), _toConsumableArray((0, _lodash.values)(MEMBER_RESTRICTED_CHANNEL_TYPES)));
exports.ALL_COMMUNITY_CHANNEL_TYPES = ALL_COMMUNITY_CHANNEL_TYPES;
var MAX_CHAT_QUERY_DATA_LIMIT = 30;
exports.MAX_CHAT_QUERY_DATA_LIMIT = MAX_CHAT_QUERY_DATA_LIMIT;
var MONUMENT_SYSTEM_CHAT_USER_ID = 'monument_system_user';
// stream.io does not support mentioning all of channel members so we fake it
// by adding unreadMentions count for such messages and highlight @here in message text
exports.MONUMENT_SYSTEM_CHAT_USER_ID = MONUMENT_SYSTEM_CHAT_USER_ID;
var MENTION_SIGN = '@';
exports.MENTION_SIGN = MENTION_SIGN;
var FAKE_HERE_USER_NAME = 'here';
exports.FAKE_HERE_USER_NAME = FAKE_HERE_USER_NAME;
var FAKE_HERE_USER = {
  id: FAKE_HERE_USER_NAME,
  name: FAKE_HERE_USER_NAME
};
exports.FAKE_HERE_USER = FAKE_HERE_USER;
var CHAT_ADMIN_ROLE_NAME = 'admin';
exports.CHAT_ADMIN_ROLE_NAME = CHAT_ADMIN_ROLE_NAME;
var COMMUNITY_EMERGENCY_RESOURCES_CHANNEL_ID = 'community_emergency_resources';
exports.COMMUNITY_EMERGENCY_RESOURCES_CHANNEL_ID = COMMUNITY_EMERGENCY_RESOURCES_CHANNEL_ID;
var USER_POSTS_FORBIDDEN_CHAT_CHANNEL_TYPES = [COMMUNITY_CHANNEL_TYPES.ADMIN_POST, COMMUNITY_CHANNEL_TYPES.ADMIN_POST_READONLY, COMMUNITY_CHANNEL_TYPES.GETTING_STARTED, SUPPORT_GROUP_CHANNEL_TYPES.PUBLIC];
exports.USER_POSTS_FORBIDDEN_CHAT_CHANNEL_TYPES = USER_POSTS_FORBIDDEN_CHAT_CHANNEL_TYPES;
var CompanyNames = {
  LLN: 'LLN',
  Monument: 'Monument'
};
exports.CompanyNames = CompanyNames;
var CompanyIds = (_CompanyIds = {}, _defineProperty(_CompanyIds, CompanyNames.LLN, 1), _defineProperty(_CompanyIds, CompanyNames.Monument, 2), _CompanyIds);
exports.CompanyIds = CompanyIds;
var MESSENGER_TABS = {
  PRIVATE: 'private',
  GROUP: 'community'
};
exports.MESSENGER_TABS = MESSENGER_TABS;
var ALLOWED_MESSAGE_ACTIONS = {
  GROUP: ['edit', 'delete', 'reactions', 'reply', 'mute', 'flag'],
  PRIVATE: ['edit', 'reactions']
};
exports.ALLOWED_MESSAGE_ACTIONS = ALLOWED_MESSAGE_ACTIONS;
var MESSAGE_PREVIEWS_TABS = {
  EMAIL: 'email',
  SMS: 'sms'
};
exports.MESSAGE_PREVIEWS_TABS = MESSAGE_PREVIEWS_TABS;
var PATIENT_COMMUNITY_CHAT_URL = '/community';
exports.PATIENT_COMMUNITY_CHAT_URL = PATIENT_COMMUNITY_CHAT_URL;
var DEFAULT_COMMUNITY_CHAT_URL = "/chat/".concat(MESSENGER_TABS.GROUP);
exports.DEFAULT_COMMUNITY_CHAT_URL = DEFAULT_COMMUNITY_CHAT_URL;
var FREE_RESPONSE_SUFFIX = '-free-response';
exports.FREE_RESPONSE_SUFFIX = FREE_RESPONSE_SUFFIX;
var MANAGE_CALENDAR_TABS = {
  SETTINGS: 'settings',
  RECURRING: 'recurring',
  DATE_SPECIFIC: 'date-specific'
};
exports.MANAGE_CALENDAR_TABS = MANAGE_CALENDAR_TABS;
var CLINICIAN_CALENDAR_MANAGE_PARENT_URL = '/availability/manage';
exports.CLINICIAN_CALENDAR_MANAGE_PARENT_URL = CLINICIAN_CALENDAR_MANAGE_PARENT_URL;
var DEFAULT_CHAT_SEPARATOR_DATE_TITLE_FORMAT = 'dddd, MMMM D YYYY [at] h:mma, z';
exports.DEFAULT_CHAT_SEPARATOR_DATE_TITLE_FORMAT = DEFAULT_CHAT_SEPARATOR_DATE_TITLE_FORMAT;